import * as types from "./actions";
import APIUtil from "./../config/APIUtil";
import UrlConstants from "./../config/UrlConstants";
import * as code from "./../config/Constants";

/**
 *
 * @desc Get Billing Details
 */
export function getBillingPaymentDetails(data) {
  let url =
    UrlConstants.getBillingPaymentDetails +
    "?userId=" +
    data.userId +
    "&invoicePeriod=" +
    data.invoicePeriod;

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      // console.log("response21212121", response);
      if (response.status === code.OK) {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: true,
          billingPaymentDetails: response,
        });
      } else {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: false,
          billingPaymentDetails: [],
        });
        //this status camed when user is deleted by admin.
        if (response.data.status === 400) {
          if (localStorage.getItem("usertype") != "ADMIN") {
            let firstOpen = localStorage.getItem("firstOpen");
            localStorage.clear();
            const currentDate = new Date();
            localStorage.setItem("lastOpenedDate", currentDate.toDateString());
            localStorage.setItem("firstOpen", firstOpen);
          } else {
            localStorage.clear();
          }
        }
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get Billing History
 */
export function getBillingHistoryAction(data) {
  let url = UrlConstants.getBillingHistory;

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BILLING_HISTORY,
          status: true,
          billingHistory: response,
        });
      } else {
        dispatch({
          type: types.BILLING_HISTORY,
          status: false,
          billingHistory: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Payment Capture if billing payment gets fail
 */
export function billingPaymentCaptureAction(data) {
  let url = UrlConstants.billingPaymentCaptureUrl;

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BILLING_PAYMENT_CAPTURE,
          status: true,
          billingHistory: response,
        });
      } else {
        dispatch({
          type: types.BILLING_PAYMENT_CAPTURE,
          status: false,
          billingHistory: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc create/ update invoice
 */
export function createOrUpdateInvoiceAction(data) {
  let url = UrlConstants.createOrUpdateInvoice;

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.CREATE_OR_UPDATE_INVOICE,
          status: true,
        });
      } else {
        dispatch({
          type: types.CREATE_OR_UPDATE_INVOICE,
          status: false,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Add billing items
 * 1-3-2023
 */
export function addBillingItems(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.addBilingitems, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: true,
            billingConfig: response,
          });
        } else {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: false,
            billingConfig: {},
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Get all billing items
 * 1-3-2023
 */
export function getAllBillingItems() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getallBilingitems, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: true,
            billingConfig: response,
          });
        } else {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: false,
            billingConfig: {},
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Edit billing items
 * 2-3-2023
 */
export function editBillingItems(data) {
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.editBilingitems, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.EDIT_CONTACT,
            billingConfig: response,
          });
        } else {
          dispatch({
            type: types.EDIT_CONTACT,
            billingConfig: response,
          });
        }
        return response.data;
      }
    );
  };
}

/**
 *
 * @desc Add billing plan
 * 1-3-2023
 */
export function addBillingPlan(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.billingPlan, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: true,
            billingConfig: response,
          });
        } else {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: false,
            billingConfig: {},
          });
        }
        return response;
      }
    );
  };
}

/**
 * get application data from tellagent application collections
 * 7-3-2023
 */
export function getApplicationData() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getapplication, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: true,
            billingConfig: response,
          });
        } else {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: false,
            billingConfig: {},
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Get all billing plan for listing
 * 9-3-2023
 */

export function getbillingPlans() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAllbillingPlans, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: true,
            billingConfig: response,
          });
        } else {
          dispatch({
            type: types.ADD_BILLING_CONFIG,
            status: false,
            billingConfig: {},
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Update isActive or isDefault flag od billing plan
 * 9-3-2023
 */

export function updateIsactiveIsdefaultFlag(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.updateIsactiveIsdefault,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          billingConfig: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          billingConfig: response,
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc Get billing plan by id
 * 10-3-2023
 */
export function getbillingPlanByid(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.getbillingPlanByid + "/" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_BILLING_CONFIG,
          status: true,
          billingConfig: response,
        });
      } else {
        dispatch({
          type: types.ADD_BILLING_CONFIG,
          status: false,
          billingConfig: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Update hole billing plan
 * 10-3-2023
 */

export function updateHolebillingPlan(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.updateHoleBillinplan,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          billingConfig: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          billingConfig: response,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get Invoice by Invoice Period
 */
export function getInvoiceByPeriodAction(data) {
  let url = UrlConstants.getInvoiceByPeriodUrl;
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: true,
          billingPaymentDetails: response,
        });
      } else {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: false,
          billingPaymentDetails: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get all account owners Billing History for Admin
 */
export function getAllOwnersBillingHistoryAction(data) {
  let url = UrlConstants.getAllOwnersBillingHistoryUrl;

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BILLING_HISTORY,
          status: true,
          billingHistory: response,
        });
      } else {
        dispatch({
          type: types.BILLING_HISTORY,
          status: false,
          billingHistory: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get all Account Owners Listing
 *
 */
export function getAllAccOwnersAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAllAccOwnersUrl, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.BILLING_HISTORY,
            status: true,
            accOwnersList: response,
          });
        } else {
          dispatch({
            type: types.BILLING_HISTORY,
            status: false,
            accOwnersList: {},
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc This function is to used for check that plan is currently allocated to user or not , if yes
 * you do not set the status inactive.
 * 18-4-2023
 */

export function checkplantoUser(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.checkplanisUsedorNot,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          billingConfig: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          billingConfig: response,
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc Get payment receipt
 */
export function getPaymentRecipt(data) {
  let url =
    UrlConstants.getPaymentReceipt +
    "?invoiceId=" +
    data.invoiceID +
    "&invoicePeriod=" +
    data.invoicePeriod;

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
      } else {
      }
      return response;
    });
  };
}

export function getBillingItemForpermissions(data) {
  let url =
    UrlConstants.getBillingItemForpermissions +
    "?userId=" +
    data.userId +
    "&invoicePeriod=" +
    data.invoicePeriod;

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      // console.log("response21212121", response);
      if (response && response.status === code.OK) {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: true,
          billingPaymentDetails: response,
        });
      } else {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: false,
          billingPaymentDetails: [],
        });
        //this status camed when user is deleted by admin.
        if (response && response.data && response.data.status === 400) {
          if (localStorage.getItem("usertype") != "ADMIN") {
            let firstOpen = localStorage.getItem("firstOpen");
            localStorage.clear();
            const currentDate = new Date();
            localStorage.setItem("lastOpenedDate", currentDate.toDateString());
            localStorage.setItem("firstOpen", firstOpen);
          } else {
            localStorage.clear();
          }
        }
      }
      return response;
    });
  };
}

export function getInvoiceByid(id) {
  return function(dispatch) {
    let url = `${UrlConstants.getInvoicebyinvoiceid}?id=${id}`;
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        // dispatch({
        //   type: types.ADD_BILLING_CONFIG,
        //   status: true,
        //   billingConfig: response,
        // });
      } else {
        // dispatch({
        //   type: types.ADD_BILLING_CONFIG,
        //   status: false,
        //   billingConfig: {},
        // });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Delete new plan
 * 23-10-2023
 */

export function deleteNewPlan(data) {
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.deleteNewPlan, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          // dispatch({
          //   type: types.EDIT_CONTACT,
          //   billingConfig: response,
          // });
        } else {
          // dispatch({
          //   type: types.EDIT_CONTACT,
          //   billingConfig: response,
          // });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Update current plan end date.
 * 23-10-2023
 */

export function updatCurrentPlanEndDate(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.updateCurrentplanEnddate,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        // dispatch({
        //   type: types.EDIT_CONTACT,
        //   billingConfig: response,
        // });
      } else {
        // dispatch({
        //   type: types.EDIT_CONTACT,
        //   billingConfig: response,
        // });
      }
      return response;
    });
  };
}
